import React, {memo, useState} from "react";
import { useStore } from "../../../../../../../hooks";
import { PrintTypes } from "../../../../../../../enums";
import { BetTicket } from "../../../../../../../models";
import { observer } from "mobx-react-lite";

interface TableRowProps {
  barCode: number;
  status: number;
  ticketId: number;
  onClick: () => void;
  rowClicked: boolean;
  rowClickedKey: string;
  isDrawPrintIcon?: boolean;
  paidAmount: number | null;
  children: React.ReactNode;
  isDrawJackpotIcon?: boolean;
  openJackpotStream?: () => void;
}

const TableRow: React.FC<TableRowProps> = observer(
  ({
    onClick,
    barCode,
    children,
    ticketId,
    rowClicked,
    rowClickedKey,
    isDrawPrintIcon,
    openJackpotStream,
    isDrawJackpotIcon,
  }) => {
    const { ticketsStore } = useStore();
    const { tickets: { data: { items } } } = ticketsStore;
    const [clicked, setClicked] = useState("");

    const openPrintPopup = (e: any) => {
      e.stopPropagation();
      const ticket: any = items.filter((item) => item.ticketId === ticketId)[0];
      const {
        amount,
        betType,
        date,
        gameId,
        possibleWin,
        status,
        betId,
        barcode,
        winAmount,
        userName,
        ticketInfos,
      } = ticket;

      const ticketPrintData: BetTicket = {
        date,
        gameId,
        status,
        amount,
        barcode,
        betId,
        betType,
        ticketId,
        winAmount,
        possibleWin,
        userName,
        ticketInfo: ticketInfos,
        roundId: ticketInfos.length === 1 ? ticketInfos[0]?.roundId : null,
      };

      ticketsStore.setTicketPrintData({
        type: PrintTypes.Bet,
        data: ticketPrintData,
      });
    };

    const handleClick = () => {
      if (rowClicked) {
        setClicked("clicked");
      }
      onClick();
    }

    return (
      <div onClick={handleClick} className={`main-table-row ${rowClickedKey || clicked ? "clicked" : ""}`}>
        {children}
        {isDrawPrintIcon ? (
          <div
            className="table-inner-item table-print-item"
            onClick={(e) => openPrintPopup(e)}
          >
            <span className="icon-print print-icon" />
          </div>
        ) : null}
        {openJackpotStream && isDrawJackpotIcon ? (
          <div
            className="table-inner-item table-print-item"
            onClick={(e) => {
              e.stopPropagation();
              openJackpotStream();
            }}
          >
            <span className="icon-arrow-outward outward-arrow" />
          </div>
        ) : null}
        {!isDrawJackpotIcon ? (
          <div className="table-inner-item table-print-item"></div>
        ) : null}
      </div>
    );
  },
);

export default memo(TableRow);
